import actionTypes from 'SRC/modules/redux/actionTypes'

export const deleteServiceProviderPhoto = id => ({
  type: actionTypes.DELETE_SERVICE_PROVIDER_PHOTO,
  payload: id
})
